import * as React from 'react';
import {Messages} from '../../codegen/Localize';
import {ButtonType, ButtonWidget, Tooltip, TooltipProps} from '@tableau/widgets';
import {PostPublishStep} from '../../ts/services/PostPublishStep';

export interface PublishDatasourceSuccessDialogProps {
  postPublishStep: PostPublishStep;
  datasourceSuccessMessage: string;
  readonly close: (result: any) => void;
}

export function PublishDatasourceSuccessDialog(props: PublishDatasourceSuccessDialogProps){
  const showWhatIsThisPopover = props.postPublishStep === PostPublishStep.OnlineSyncRefresh || props.postPublishStep === PostPublishStep.OnlineLiveQuerySync;
  const showIconWithPopover = props.postPublishStep === PostPublishStep.ServerTriggeredClientRefresh;

  const popOverTriggerMessage = Messages.publishDatasourceSuccessDialogText_onlineSync_whatsthis();
  const popOverMessage = Messages.publishDatasourceSuccessDialogText_onlineSync_help();
  const popOverTriggerMessageSpan: React.ReactElement = <span className= "tb-datasource-publish-details-popover-trigger">{popOverTriggerMessage}</span>;

  const tooltipProps: TooltipProps = {
    getContent: () => <span>{popOverMessage}</span>,
  };

  return <div className="tb-datasource-publish-success-modal">
    <div className="tb-dialog-body-text">
      <div className="tb-datasource-publish-name">
        <span className="tb-link-datasource"/>
        <span className="tb-box">{props.datasourceSuccessMessage} </span>
      </div>
      <span className = "tb-box tb-datasource-publish-details"> {getPublishDetailString(props.postPublishStep)}
        { showWhatIsThisPopover &&
        <span>
        <span>&nbsp;</span>
        <Tooltip {...tooltipProps}>{popOverTriggerMessageSpan}</Tooltip>
        </span>}
        { showIconWithPopover &&
        <span>
        <span>&nbsp;</span>
        <Tooltip {...tooltipProps}/>
        </span>}
      </span>
    </div>

    <div className="tb-dialog-actions">
      {createGoButtonWidget(props)}
    </div>
  </div>;
}

function createGoButtonWidget(props: PublishDatasourceSuccessDialogProps) {
  let title = '';
  let testId = '';
  switch (props.postPublishStep) {
    case PostPublishStep.Done: {
      title = Messages.publishDatasourceSuccessDialogButton_live();
      testId = 'publishDatasourceSuccessDialogButton_live';
      break;
    }
    case PostPublishStep.ServerRefresh: {
      title = Messages.publishDatasourceSuccessDialogButton_server();
      testId = 'publishDatasourceSuccessDialogButton_server';
      break;
    }
    case PostPublishStep.OnlineSyncRefresh: {
      title =  Messages.publishDatasourceSuccessDialogButton_onlineSync();
      testId = 'publishDatasourceSuccessDialogButton_onlineSync';
      break;
    }
    case PostPublishStep.OnlineLiveQuerySync: {
      title = Messages.publishDatasourceSuccessDialogButton_onlineLQS();
      testId = 'publishDatasourceSuccessDialogButton_onlineLQS';
      break;
    }
    case PostPublishStep.ServerTriggeredClientRefresh: {
      title = Messages.publishDatasourceSuccessDialogButton_serverTriggeredClientRefresh();
      testId = 'publishDatasourceSuccessDialogButton_serverTriggeredClientRefresh';
      break;
    }
    default:
      break;
  }

  return  <ButtonWidget
    handleClick={props.close}
    buttonType={ButtonType.Outline}
    testId={testId}
  >
    <span>{title}</span>
  </ButtonWidget>;
}

function getPublishDetailString(postPublishStep: PostPublishStep): string{
  switch (postPublishStep) {
    case PostPublishStep.Done:
      return Messages.publishDatasourceSuccessDialogText_live();
    case PostPublishStep.ServerRefresh:
      return Messages.publishDatasourceSuccessDialogText_server();
    case PostPublishStep.OnlineSyncRefresh:
      return Messages.publishDatasourceSuccessDialogText_onlineSync();
    case PostPublishStep.OnlineLiveQuerySync:
      return Messages.publishDatasourceSuccessDialogText_onlineLQS();
    case PostPublishStep.ServerTriggeredClientRefresh:
      return Messages.publishDatasourceSuccessDialogText_serverTriggeredClientRefresh();
    default:
      return null;
  }
}

